import { auth } from '@/plugins/auth';
import axios, { type AxiosRequestConfig, type AxiosResponse } from 'axios';
import qs from 'qs';
// TODO: Setup check for token expiration
// + redirect user to relog when token expired
// + investigate usage of api returning a property for
// relog needed and then checking for it in response

export const api = axios.create({
  withCredentials: true,
  baseURL: import.meta.env.VITE_CMDC_API_URL,
});

api.defaults.paramsSerializer = (params) => qs.stringify(params, { indices: false });

export const jsonInterceptor = api.interceptors.request.use((config) => {
  config.headers['Content-Type'] = 'application/json';
  return config;
});

api.interceptors.request.use(async (config) => {
  const { getAccessTokenSilently, loginWithRedirect } = auth;
  try {
    // Automatic token management with Auth0
    const token = await getAccessTokenSilently();
    config.headers.Authorization = `Bearer ${token}`;
  } catch {
    loginWithRedirect();
  }
  return config;
});

export const cancelableApiRequest = <T>(
  config: AxiosRequestConfig
): {
  request: Promise<AxiosResponse<T>>;
  cancel: () => void;
} => {
  const cancelTokenSource = axios.CancelToken.source();

  const request = api.request<T>({
    ...config,
    cancelToken: cancelTokenSource.token,
  });

  return {
    request,
    cancel: () => cancelTokenSource.cancel(),
  };
};
